import {api} from '@/http'

// 招聘会列表
const getActivityList = (data, callback, back) => {
  api('/api/activity', 'get', data, callback, back)
}

// 预约参会
const orderJoin = (id, callback) => {
  api('/api/activity/' + id + '/reserve_toggle', 'post', '', callback)
}

// 招聘会详情
const getActivityDesc = (id, callback, back) => {
  api('/api/activity/' + id, 'get', '', callback, back)
}

// 招聘会参会企业
const getActivityCompanyList = (id, data, callback, back) => {
  api('/api/activity/' + id + '/enterprise', 'get', data, callback, back)
}

// 招聘会企业详情
const getActivityCompanyDesc = (id, callback, back) => {
  api('/api/activity/enterprise/' + id, 'get', '', callback, back)
}

// 招聘会企业职位列表
const getActivityPosition = (id, data, callback, back) => {
  api('/api/activity/enterprise/' + id + '/position', 'get', data, callback, back)
}

// 招聘会职位详情
const getActivePositionDesc = (id, callback, back) => {
  api('/api/activity/enterprise/position/' + id, 'get', '', callback, back)
}

// 获取当前简历详情
const getResumeNow = (callback, error) => {
  api('/api/resume/base', 'get', '', callback, '', error)
}

// 设置简历军人身份
const setResumeSoldier = (data, callback, back) => {
  api('/api/resume/base/soldier', 'put', data, callback, back)
}

export default {
  getActivityList,
  orderJoin,
  getActivityDesc,
  getActivityCompanyList,
  getActivityCompanyDesc,
  getActivityPosition,
  getActivePositionDesc,
  getResumeNow,
  setResumeSoldier
}



// WEBPACK FOOTER //
// ./src/api/jobFair/index.js